import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AnalStatsResponse, DateRange } from "./analytics.interface";

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  constructor(private http: HttpClient) {}

  getAnalytics(dateRange: DateRange): Observable<AnalStatsResponse> {
    const params: Record<string, string> = {
      from: dateRange.from.toISOString(),
    };
    if (dateRange.to) {
      params["to"] = dateRange.to.toISOString();
    }
    return this.http.get<AnalStatsResponse>("/analytics", { params });
  }
}
